// ne 06 - 01 - 21

//Email Logs
export const FETCH_EMAIL_LOGS = "FETCH_EMAIL_LOGS";
export const FETCH_EMAIL_LOGS_SUCCESS = "FETCH_EMAIL_LOGS_SUCCESS";
export const FETCH_EMAIL_LOGS_ERROR = "FETCH_EMAIL_LOGS_ERROR";
export const CLEAR_EMAIL_LOGS = "CLEAR_EMAIL_LOGS";
export const SET_EMAIL_LOGS_PAGE = "SET_EMAIL_LOGS_PAGE";
